import * as types from './types';
import createReducer from '../../createReducer';

const initialState = {
  list: [],
  current: {},
  loading: false,
  pagination: {},
  fetchedCreateTask: false,
  fetchingUpdateTask: false,
  fetchingCreateTask: false,
  fetchedUpdateTask: false,
};

const tasksReducer = createReducer(initialState)({
  // GET TASKS
  [types.FETCH_TASKS_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.FETCH_TASKS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      list: payload.data,
      pagination: payload.pagination,
    };
  },
  [types.FETCH_TASKS_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },
  // CREATE TASKS
  [types.FETCH_CREATE_TASK_REQUEST]: (state) => {
    return {
      ...state,
      fetchedCreateTask: false,
      fetchingCreateTask: true,
    };
  },
  [types.FETCH_CREATE_TASK_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchedCreateTask: true,
      fetchingCreateTask: false,
    };
  },
  [types.FETCH_CREATE_TASK_FAILED]: (state) => {
    return {
      ...state,
      fetchedCreateTask: false,
      fetchingCreateTask: false,
    };
  },
  // GET TASK BY ID
  [types.FETCH_TASK_BY_ID_REQUEST]: (state) => {
    return {
      ...state,
      loading: true,
    };
  },
  [types.FETCH_TASK_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      loading: false,
      current: payload,
    };
  },
  [types.FETCH_TASK_BY_ID_FAILED]: (state) => {
    return {
      ...state,
      loading: false,
    };
  },
  // UPDATE TASK
  [types.FETCH_UPDATE_TASK_REQUEST]: (state) => {
    return {
      ...state,
      fetchingUpdateTask: true,
      fetchedUpdateTask: false,
    };
  },
  [types.FETCH_UPDATE_TASK_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      fetchingUpdateTask: false,
      current: payload,
      fetchedUpdateTask: true,
    };
  },
  [types.FETCH_UPDATE_TASK_FAILED]: (state) => {
    return {
      ...state,
      fetchingUpdateTask: false,
      fetchedUpdateTask: false,
    };
  },
  [types.RESET_CURRENT_TASK]: (state) => {
    return {
      ...state,
      current: {},
    };
  },
});

export default tasksReducer;
